import { render } from "./meetingselector.vue?vue&type=template&id=2f96752a&scoped=true"
import script from "./meetingselector.vue?vue&type=script&lang=js"
export * from "./meetingselector.vue?vue&type=script&lang=js"

import "./meetingselector.vue?vue&type=style&index=0&id=2f96752a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96752a"]])

export default __exports__